import { createAction, props } from '@ngrx/store';
import { EnvironmentResponse } from './environment.models';

export const initEnvironment = createAction('[Environment Page] Init');

export const loadEnvironmentSuccess = createAction(
  '[Environment/API] Load Environment Success',
  props<{ environment: EnvironmentResponse }>()
);

export const loadEnvironmentFailure = createAction(
  '[Environment/API] Load Environment Failure',
  props<{ error: any }>()
);
